"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.activateFlight = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const actionLayout_1 = require("../../../Table/columns/actionsColumn/actionLayout");
const views = {
    activate: {
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Action:activateTitle', defaultMessage: 'Activate flight' })),
        iconName: 'eye',
        targetOption: 'activate',
    },
    deactivate: {
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Action:deactivateTitle', defaultMessage: 'Deactivate flight' })),
        iconName: 'eye-crossed',
        targetOption: 'deactivate',
    },
};
exports.activateFlight = (0, actionLayout_1.createActionLayout)([
    (state) => state === 'deactivate' ? views.activate : views.deactivate,
]);
//# sourceMappingURL=activateFlight.js.map